/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiDefaultTheme from './lui-default-theme'
import LuiDefaultThemeCss from './theme/lui-default-theme.global.scss'

// Deprecated
// Left for backward compatibility, will be removed in future versions.
import LuiDesktoplayerTheme from './lui-desktoplayer-theme'
import LuiDesktoplayerCss from './theme/lui-desktoplayer-theme.global.scss'
import LuiContextchromelayerTheme from './lui-contextchromelayer-theme'
import LuiContextchromelayerCss from './theme/lui-contextchromelayer-theme.global.scss'
import LuiCanvaslayerTheme from './lui-canvaslayer-theme'
import LuiCanvaslayerCss from './theme/lui-canvaslayer-theme.global.scss'
import LuiContentchromelayerTheme from './lui-contentchromelayer-theme'
import LuiContentchromelayerCss from './theme/lui-contentchromelayer-theme.global.scss'
import LuiBrandmembranelayerTheme from './lui-brandmembranelayer-theme'
import LuiBrandmembranelayerCss from './theme/lui-brandmembranelayer-theme.global.scss'

window.lui.registerComponent(LuiDefaultTheme, LuiDefaultThemeCss)

window.lui.registerComponent(LuiDesktoplayerTheme, LuiDesktoplayerCss)
window.lui.registerComponent(LuiContextchromelayerTheme, LuiContextchromelayerCss)
window.lui.registerComponent(LuiCanvaslayerTheme, LuiCanvaslayerCss)
window.lui.registerComponent(LuiContentchromelayerTheme, LuiContentchromelayerCss)
window.lui.registerComponent(LuiBrandmembranelayerTheme, LuiBrandmembranelayerCss)



//////////////////
// WEBPACK FOOTER
// ./packages/lui-layer-theme/index.js
// module id = 150
// module chunks = 0 1 19